import immutableStore from 'utils/immutableStore';
import alt from 'components/Dispatcher';
import ScorecardSchemeLabelActions from 'actions/scorecards/ScorecardSchemeLabelActions';
import {List, Record} from 'immutable';

@immutableStore
class ScorecardSchemeLabelStore {
  constructor() {
    this.state = new Record({
      labels: List(),
      labelsLoading: false,
      labelsError: false,
      saveLoading: false,
      saveError: false,
    })();

    this.bindActions(ScorecardSchemeLabelActions);
  }

  labels() {
    this.setState({
      labels: List(),
      labelsLoading: true,
      labelsError: false,
    });
  }

  labelsSuccess(labels) {
    this.setState({
      labels: labels,
      labelsLoading: false,
      labelsError: false,
    });
  }

  labelsError(e) {
    this.setState({
      labels: List(),
      labelsLoading: false,
      labelsError: true,
    });
  }

  save() {
    this.setState({
      saveLoading: true,
      saveError: false,
    });
  }

  saveSuccess(labels) {
    this.setState({
      labels: labels,
      saveLoading: false,
      saveError: false,
    });
  }

  saveError(e) {
    this.setState({
      saveLoading: false,
      saveError: true,
    });
  }
}

export default alt.createStore(ScorecardSchemeLabelStore, 'ScorecardSchemeLabelStore');
